// Topic : API Field Name => InternalEditField__c => (orbject: CTRRequestFormHeader__c)
export const API_FIELD_NAME_SF = [
  {
    Label: "Account Group",
    Api: "AccountGroup__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Building Code (Local)",
    Api: "BuildingCodeLocal__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Building Code (EN)",
    Api: "BuildingCodeEN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "City/State (Local)",
    Api: "CityStateLocal__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "City/State for Invoice (Local)",
    Api: "CityStateLocalText__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "City/State (EN)",
    Api: "ProvinceEN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "City/State for Invoice (EN)",
    Api: "ProvinceENText__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "c/o (Local)",
    Api: "CoName__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "c/o (EN)",
    Api: "CoNameEN__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "Country",
    Api: "Country__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName1 (EN)",
    Api: "CustomerNameEN1__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName2 (EN)",
    Api: "CustomerNameEN2__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName3 (EN)",
    Api: "CustomerNameEN3__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName4 (EN)",
    Api: "CustomerNameEN4__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName1 (Local)",
    Api: "CustomerNameLocal1__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName2 (Local)",
    Api: "CustomerNameLocal2__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName3 (Local)",
    Api: "CustomerNameLocal3__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "CustomerName4 (Local)",
    Api: "CustomerNameLocal4__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Customer Search Term (EN)",
    Api: "CustomerSearchTermEN__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Customer Search Term (Other Languages)",
    Api: "CustomerSearchTermLocal__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Customer Search Term 2 (EN)",
    Api: "CustomerSearchTerm2EN__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Customer Search Term 2 (Other Languages)",
    Api: "CustomerSearchTerm2Local__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Customer Type (SAP)",
    Api: "CustomerTypeSAP__c",
    Type: "TOPCustomer;",
  },
  {
    Label: "District (EN)",
    Api: "DistrictENText__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "District (Local)",
    Api: "DistrictLocalText__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Email Address",
    Api: "Email__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Fax",
    Api: "Fax__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Country Code (Fax)",
    Api: "FaxCountryCode__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Fax (Ext.)",
    Api: "FaxExtension__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Floor (Local)",
    Api: "FloorLocal__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "Floor (EN)",
    Api: "FloorEN__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "Group Key (Account  Key of Bank)",
    Api: "GroupKeyAccountKeyofBank__c",
    Type: "TXSupplier",
  },
  {
    Label: "House no. (Local)",
    Api: "HousenoLocal__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "House no. (EN)",
    Api: "HousenoEN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Industry",
    Api: "Industry__c",
    Type: "TOPCustomer",
  },
  {
    Label: "Language",
    Api: "Language__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Country Code (Mobile)",
    Api: "MobileCountryCode__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Mobile",
    Api: "MobilePhone__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Phone",
    Api: "Phone__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Country Code (Phone)",
    Api: "PhoneCountryCode__c",
    Type: "TOPCustomer;TOPSupplier;TXSupplier",
  },
  {
    Label: "Phone (Ext.)",
    Api: "PhoneExtension__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Postal Code (Local)",
    Api: "PostalCodeLocalText__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Postal Code (EN)",
    Api: "PostalCodeENText__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Region",
    Api: "RegionSAP__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Region",
    Api: "Regions__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Room (Local)",
    Api: "RoomLocal__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "Room (EN)",
    Api: "RoomEN__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "Street2 (EN)",
    Api: "Street2EN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street2 (Local)",
    Api: "Street2Local__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street3 (EN)",
    Api: "Street3EN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street3 (Local)",
    Api: "Street3Local__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street4 (EN)",
    Api: "Street4EN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street4 (Local)",
    Api: "Street4Local__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street5 (EN)",
    Api: "Street5EN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street5 (Local)",
    Api: "Street5Local__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street (EN)",
    Api: "StreetEN__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Street (Local)",
    Api: "StreetLocal__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Supplier Search Term (EN)",
    Api: "SupplierSearchTermEN__c",
    Type: "TOPSupplier;TXSupplier",
  },
  {
    Label: "Supplier Search Term (Other Languages)",
    Api: "SupplierSearchTermLocal__c",
    Type: "TOPSupplier;TXSupplier",
  },
  {
    Label: "Supplier Search Term 2 (EN)",
    Api: "SupplierSearchTerm2EN__c",
    Type: "TOPSupplier;TXSupplier",
  },
  {
    Label: "Supplier Search Term 2 (Other Languages)",
    Api: "SupplierSearchTerm2Local__c",
    Type: "TOPSupplier;TXSupplier",
  },
  {
    Label: "TAX Classification (Thailand)",
    Api: "TaxClassification__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "TAX Classification (Vietnam)",
    Api: "TaxClassificationVN__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "TAX Classification (Indonesia)",
    Api: "TaxClassificationID__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "TAX Classification (Singapore)",
    Api: "TaxClassificationSG__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "TAX Classification (India)",
    Api: "TaxClassificationIN__c",
    Type: "TOPCustomer;TXCustomer",
  },
  {
    Label: "Tax Number",
    Api: "TaxCode1__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Trading Partner",
    Api: "TradingPartner__c",
    Type: "TXCustomer;TXSupplier",
  },
  {
    Label: "Transportation Zone",
    Api: "TransportationZone__c",
    Type: "TOPCustomer;TOPSupplier;TXCustomer;TXSupplier",
  },
  {
    Label: "Type of Business (Branch)",
    Api: "TypeofBusinessBranch__c",
    Type: "TOPCustomer",
  },
  {
    Label: "CEOPresidentMD First Name",
    Api: "CEOFirstName__c",
    Type: "All",
  },
  {
    Label: "CEOPresidentMD Last Name",
    Api: "CEOLastName__c",
    Type: "All",
  },
  {
    Label:
      "Company's latest credit rating by international agencies (Please specify if e.g. BBB, Baa2)",
    Api: "CompanyLatestCreditRating__c",
    Type: "All",
  },
  {
    Label: "Company Name (English)",
    Api: "CompanyNameENF__c",
    Type: "Edit",
  },
  {
    Label: "Company Name (Other Languages)",
    Api: "CompanyNameLocal__c",
    Type: "Edit",
  },
  {
    Label: "Full Steet (EN)",
    Api: "FullStreetEN__c",
    Type: "Edit",
  },
  {
    Label: "Full Street (Local)",
    Api: "FullStreetLocal__c",
    Type: "Edit",
  },
  {
    Label: "Estimate monthly purchase per grade",
    Api: "CompanyPurchasingVolumnperGrade__c",
    Type: "All",
  },
  {
    Label: "Company Website",
    Api: "CompanyWebsite__c",
    Type: "All",
  },
  {
    Label: "Title (Mr.Mrs.Missetc.)",
    Api: "ContactSalutation__c",
    Type: "All",
  },
  {
    Label: "Governance: Does your company have Corporate Governance policy?",
    Api: "CorporateGovernancePolicy__c",
    Type: "All",
  },
  {
    Label: "Where do customers buy this product?",
    Api: "CustomerPurchaseProductFrom__c",
    Type: "All",
  },
  {
    Label: "Customer's Facility (Tank and Storage)",
    Api: "CustomersFacilityTankAndStorage__c",
    Type: "All",
  },
  {
    Label: "Customer's Facility (Transportation)",
    Api: "CustomersFacilityTransportation__c",
    Type: "All",
  },
  {
    Label: "Environment: Does your company have Environment policy?",
    Api: "EnvironmentPolicy__c",
    Type: "All",
  },
  {
    Label: "Unit of Purchasing volume per month",
    Api: "EstimatedMonthlyPurchaseUnit__c",
    Type: "All",
  },
  {
    Label: "First Name",
    Api: "FirstName__c",
    Type: "All",
  },
  {
    Label: "The Former Name of Company (if any)",
    Api: "FormerNameofCompany__c",
    Type: "All",
  },
  {
    Label:
      "(For Supplier) Has your company ever failed to supply under any agreement in the last 3 years? (Please specify the reason of the default)",
    Api: "HasFailedSupplyInLast3Years__c",
    Type: "All",
  },
  {
    Label:
      "Has your company or any of its affiliates, or any current director, officer, or key employee ever been charged with, or investigated for fraud, misrepresentation, corruption, bribery, money laundering, forced labour, environmental issues or other related activities during the past five years?",
    Api: "HasIssuesDuringThePast5Years__c",
    Type: "All",
  },
  {
    Label:
      "Does your company have any offices, transactions, investments, activities or planned activities in sanctioned targets or any transactions, investments, activities or planned activities with (or in) any person or entity located in sanctioned targets with (or in) any entity owned controlled by any entity located in sanctioned targets*? (Please specify the reason of the default)",
    Api: "HasSanctionedTarget__c",
    Type: "All",
  },
  {
    Label: "Human Rights: Does your company have Human Rights policy?",
    Api: "HumanRightsPolicy__c",
    Type: "All",
  },
  {
    Label: "Immediate Parent Company",
    Api: "ImmidiateParentCompany__c",
    Type: "All",
  },
  {
    Label: "Incorporation Date",
    Api: "IncoperationDate__c",
    Type: "All",
  },
  {
    Label: "Last Name",
    Api: "LastName__c",
    Type: "All",
  },
  {
    Label: "Legal Entity",
    Api: "LegalEntity__c",
    Type: "All",
  },
  {
    Label: "Other Legal Entity (Please Specify)",
    Api: "LegalEntityOthers__c",
    Type: "All",
  },
  {
    Label: "Location in Google Maps (Latitude)",
    Api: "Location__Latitude__s",
    Type: "All",
  },
  {
    Label: "Location in Google Maps (Longtitude)",
    Api: "Location__Longitude__s",
    Type: "All",
  },
  {
    Label: "Location in Google Maps (Link)",
    Api: "LocationInGoogleMapsLinks__c",
    Type: "All",
  },
  {
    Label: "Building Code (Mailing)",
    Api: "MailingBuildingCode__c",
    Type: "All",
  },
  {
    Label: "City/State (Mailing)",
    Api: "MailingCity__c",
    Type: "All",
  },
  {
    Label: "District (Mailing)",
    Api: "MailingDistrict__c",
    Type: "All",
  },
  {
    Label: "Floor (Mailing)",
    Api: "MailingFloor__c",
    Type: "All",
  },
  {
    Label: "House no. (Mailing)",
    Api: "MailingHousenoLocal__c",
    Type: "All",
  },
  {
    Label: "Postal Code (Mailing)",
    Api: "MailingPostalCode__c",
    Type: "All",
  },
  {
    Label: "Room (Mailing)",
    Api: "MailingRoom__c",
    Type: "All",
  },
  {
    Label: "Street (Mailing)",
    Api: "MailingStreet__c",
    Type: "All",
  },
  {
    Label: "Sub District (Mailing)",
    Api: "MailingSubDistrict__c",
    Type: "All",
  },
  {
    Label: "City/State for Invoice (Mailing)",
    Api: "MailingCityText__c",
    Type: "All",
  },
  {
    Label: "Main Product",
    Api: "MainProduct__c",
    Type: "All",
  },
  {
    Label: "Main Service",
    Api: "MainService__c",
    Type: "All",
  },
  {
    Label: "Nickname",
    Api: "Nickname__c",
    Type: "All",
  },
  {
    Label: "Got Energy Ministry's oil trader letter?",
    Api: "NoOfRegistrationMinistryEnergy__c",
    Type: "All",
  },
  {
    Label:
      "Occupational Health and Safety: Does your company have Occupational Health and Safety policy?",
    Api: "OccupationalHealthAndSafetyPolicy__c",
    Type: "All",
  },
  {
    Label: "Other Main Product",
    Api: "OtherMainProduct__c",
    Type: "All",
  },
  {
    Label: "Other Main Service",
    Api: "OtherMainService__c",
    Type: "All",
  },
  {
    Label:
      "(For Customer) Has your company ever had any default payment over the amount of USD 50,000 in the last 3 years?",
    Api: "PaymentOverTheAmountOfUSD__c",
    Type: "All",
  },
  {
    Label: "Position",
    Api: "Position__c",
    Type: "All",
  },
  {
    Label:
      "(For Customer) Has your company ever had any default payment over the amount of USD 50,000 in the last 3 years? (Please specify the reason of the default)",
    Api: "ReasonOfTheDefault__c",
    Type: "All",
  },
  {
    Label: "Same as Registered Addres (Local)",
    Api: "SameRegisteredAddress__c",
    Type: "All",
  },
  {
    Label: "Same as Registered Address (EN)",
    Api: "SameRegisteredAddressEN__c",
    Type: "All",
  },
  {
    Label:
      "Society Responsibility: Does your company have Social Responsibility policy?",
    Api: "SocialResponsibilityPolicy__c",
    Type: "All",
  },
  {
    Label:
      "(For Supplier) Has your company ever failed to supply under any agreement in the last 3 years? (Please specify the reason of the default)",
    Api: "SpecifyFailedSupplyInLast3Years__c",
    Type: "All",
  },
  {
    Label:
      "Has your company or any of its affiliates, or any current director, officer, or key employee ever been charged with, or investigated for fraud, misrepresentation, corruption, bribery, money laundering, forced labour, environmental issues or other related activities during the past five years? (Please Specify the reason of the default)",
    Api: "SpecifyIssuesDuringThePast5Years__c",
    Type: "All",
  },
  {
    Label: "Specify Languages of Company Name",
    Api: "SpecifyLanguagesOfCompanyName__c",
    Type: "All",
  },
  {
    Label:
      "Does your company have any offices, transactions, investments, activities or planned activities in sanctioned targets or any transactions, investments, activities or planned activities with (or in) any person or entity located in sanctioned targets with (or in) any entity owned controlled by any entity located in sanctioned targets*? (Please specify the reason of the default)",
    Api: "SpecifySanctionedTarget__c",
    Type: "All",
  },
  {
    Label: "Tentative Starting Trading Date?",
    Api: "StartTradingDate__c",
    Type: "All",
  },
  {
    Label: "Sub District (Local)",
    Api: "SubDistrictLocalText__c",
    Type: "All",
  },
  {
    Label: "Supplier's Facility (Tank and Storage)",
    Api: "SuppliersFacilityTankAndStorage__c",
    Type: "All",
  },
  {
    Label: "Supplier's Facility (Transportation)",
    Api: "SuppliersFacilityTransportation__c",
    Type: "All",
  },
  {
    Label: "Supplying this product to which company?",
    Api: "SupplierSupplyProductTo__c",
    Type: "All",
  },
  {
    Label: "Supplier Type",
    Api: "SupplierType__c",
    Type: "All",
  },
  {
    Label: "Type of Business",
    Api: "TypeOfBusinessCommercialEvaluation__c",
    Type: "All",
  },
  {
    Label: "Other Type of Business (Please Specify)",
    Api: "TypeOfBusinessOthers__c",
    Type: "All",
  },
  {
    Label: "Years of Experience in business?",
    Api: "YearsofExperience__c",
    Type: "All",
  },
  {
    Label: "Company Name (Alias)",
    Api: "AliasEN__c",
    Type: "All",
  },
];

export const REQUEST_HEADER_EXTRACT = {
  Id: "Id",
  Customer: "Customer__c",
  CompanyNameENF: "CompanyNameENF__c",
  CompanyNameLocal: "CompanyNameLocal__c",
  CompanyNameLanguage: "SpecifyLanguagesOfCompanyName__c",
  Language: "Language__c",
  FormerNameofCompany: "FormerNameofCompany__c",
  CustomerType: "CustomerType__c",
  SupplierType: "SupplierType__c",
  TypeOfBusinessCommercialEvaluation: "TypeOfBusinessCommercialEvaluation__c",
  TypeOfBusinessOthers: "TypeOfBusinessOthers__c",
  LegalEntity: "LegalEntity__c",
  LegalEntityOthers: "LegalEntityOthers__c",
  IncoperationDate: "IncoperationDate__c",
  YearsofExperience: "YearsofExperience__c",
  TaxCode1: "TaxCode1__c",
  CompanyWebsite: "CompanyWebsite__c",
  NoOfRegistrationMinistryEnergy: "NoOfRegistrationMinistryEnergy__c",
  HousenoLocal: "HousenoLocal__c",
  BuildingCodeLocal: "BuildingCodeLocal__c",
  RoomLocal: "RoomLocal__c",
  FloorLocal: "FloorLocal__c",
  StreetLocal: "StreetLocal__c",
  SubDistrictLocalText: "SubDistrictLocalText__c",
  DistrictLocalText: "DistrictLocalText__c",
  CityStateLocal: "CityStateLocal__c",
  Country: "Country__c",
  PostalCodeLocalText: "PostalCodeLocalText__c",
  LocationInGoogleMapsLinks: "LocationInGoogleMapsLinks__c",
  LocationInGoogleMapsGeolocationLatitude:
    "LocationInGoogleMapsGeolocation__Latitude__s",
  LocationInGoogleMapsGeolocationLongitude:
    "LocationInGoogleMapsGeolocation__Longitude__s",
  SameRegisteredAddress: "SameRegisteredAddress__c",
  MailingHousenoLocal: "MailingHousenoLocal__c",
  MailingBuildingCode: "MailingBuildingCode__c",
  MailingRoom: "MailingRoom__c",
  MailingFloor: "MailingFloor__c",
  MailingStreet: "MailingStreet__c",
  MailingSubDistrict: "MailingSubDistrict__c",
  MailingDistrict: "MailingDistrict__c",
  MailingCity: "MailingCity__c",
  MailingCountry: "MailingCountry__c",
  MailingPostalCode: "MailingPostalCode__c",
  ContactSalutation: "ContactSalutation__c",
  NickName: "NickName__c",
  FirstName: "FirstName__c",
  LastName: "LastName__c",
  Position: "Position__c",
  Email: "Email__c",
  MobileCountryCode: "MobileCountryCode__c",
  MobilePhone: "MobilePhone__c",
  PhoneCountryCode: "PhoneCountryCode__c",
  Phone: "Phone__c",
  FaxCountryCode: "FaxCountryCode__c",
  Fax: "Fax__c",
  InterestedProductTypeAsCustomerTOP: "InterestedProductTypeAsCustomerTOP__c",
  LubeBaseProduct: "LubeBaseProduct__c",
  LABIXProduct: "LABIXProduct__c",
  CustomerProductIdentification: "CustomerProductIdentification__c",
  InterestedProductTypeAsSupplierTOP: "InterestedProductTypeAsSupplierTOP__c",
  PetroleumAndComponentsProducts: "PetroleumAndComponentsProducts__c",
  SupplierProductIdentification: "SupplierProductIdentification__c",
  CompanyPurchasingVolumnperGrade: "CompanyPurchasingVolumnperGrade__c",
  EstimatedMonthlyPurchaseUnit: "EstimatedMonthlyPurchaseUnit__c",
  StartTradingDate: "StartTradingDate__c",
  RelatedInformation: "RelatedInformation__c",
  CustomerPurchaseProductFrom: "CustomerPurchaseProductFrom__c",
  SupplierSupplyProductTo: "SupplierSupplyProductTo__c",
  CustomersFacilityTankAndStorage: "CustomersFacilityTankAndStorage__c",
  CustomersFacilityTransportation: "CustomersFacilityTransportation__c",
  SuppliersFacilityTankAndStorage: "SuppliersFacilityTankAndStorage__c",
  SuppliersFacilityTransportation: "SuppliersFacilityTransportation__c",
  EnvironmentPolicy: "EnvironmentPolicy__c",
  SocialResponsibilityPolicy: "SocialResponsibilityPolicy__c",
  CorporateGovernancePolicy: "CorporateGovernancePolicy__c",
  OccupationalHealthAndSafetyPolicy: "OccupationalHealthAndSafetyPolicy__c",
  HumanRightsPolicy: "HumanRightsPolicy__c",
  HasIssuesDuringThePast5Years: "HasIssuesDuringThePast5Years__c",
  SpecifyIssuesDuringThePast5Years: "SpecifyIssuesDuringThePast5Years__c",
  PaymentOverTheAmountOfUSD: "PaymentOverTheAmountOfUSD__c",
  ReasonOfTheDefault: "ReasonOfTheDefault__c",
  HasFailedSupplyInLast3Years: "HasFailedSupplyInLast3Years__c",
  SpecifyFailedSupplyInLast3Years: "SpecifyFailedSupplyInLast3Years__c",
  HasSanctionedTarget: "HasSanctionedTarget__c",
  SpecifySanctionedTarget: "SpecifySanctionedTarget__c",
  CEOFirstName: "CEOFirstName__c",
  CEOLastName: "CEOLastName__c",
  ImmidiateParentCompany: "ImmidiateParentCompany__c",
  UltimateParentCompany: "UltimateParentCompany__c",
  MainService: "MainService__c",
  OtherMainService: "OtherMainService__c",
  MainProduct: "MainProduct__c",
  OtherMainProduct: "OtherMainProduct__c",
  CompanyLatestCreditRating: "CompanyLatestCreditRating__c",
  IsSubmitted: "IsSubmitted__c",
  RegistrationStep: "RegistrationStep__c",
  AgreeToCookiePolicy: "AgreeToCookiePolicy__c",
  AgreeToPrivacyPolicy: "AgreeToPrivacyPolicy__c",
  InternalEditField: "InternalEditField__c",
};

export const REQUEST_HEADER = {
  RequestFormHeaderId: "RequestFormHeaderId__c",
  CustomerId: "CustomerId__c",
  RegistrationNumber: "RegistrationNumber__c",
  CompanyNameEN: "CompanyNameENF__c",
  CompanyNameLocal: "CompanyNameLocal__c",
  CompanyNameLanguage: "SpecifyLanguagesOfCompanyName__c",
  CompanyNameFormer: "FormerNameofCompany__c",
  CompanyNameAlias: "AliasEN__c",
  CustomerType: "CustomerType__c",
  SupplierType: "SupplierType__c",
  BusinessType: "TypeOfBusinessCommercialEvaluation__c",
  BusinessTypeOthers: "TypeOfBusinessOthers__c",
  LegalEntityType: "LegalEntity__c",
  LegalEntityTypeOthers: "LegalEntityOthers__c",
  IncorporationDate: "IncoperationDate__c",
  YearsOfExperience: "YearsofExperience__c",
  TAXNumber: "TaxCode1__c",
  Website: "CompanyWebsite__c",
  MinistryOfEnergyRegistrationNo: "NoOfRegistrationMinistryEnergy__c",
  HouseNo: "HousenoLocal__c",
  Building: "BuildingCodeLocal__c",
  Room: "RoomLocal__c",
  Floor: "FloorLocal__c",
  Street: "StreetLocal__c",
  SubDistrict: "SubDistrictLocalText__c",
  District: "DistrictLocalText__c",
  City: "CityStateLocal__c",
  Country: "Country__c",
  PostalCode: "PostalCodeLocalText__c",
  HouseNoEN: "HousenoEN__c",
  BuildingEN: "BuildingCodeEN__c",
  RoomEN: "RoomEN__c",
  FloorEN: "FloorEN__c",
  StreetEN: "FullStreetEN__c",
  SubDistrictEN: "Street4EN__c",
  DistrictEN: "DistrictENText__c",
  CityEN: "ProvinceEN__c",
  PostalCodeEN: "PostalCodeENText__c",
  LocationURL: "LocationInGoogleMapsLinks__c",
  Latitude: "LocationInGoogleMapsGeolocation__Latitude__s",
  Longitude: "LocationInGoogleMapsGeolocation__Longitude__s",
  MailingIsSameAsRegistered: "SameRegisteredAddress__c",
  MailingHouseNo: "MailingHousenoLocal__c",
  MailingBuilding: "MailingBuildingCode__c",
  MailingRoom: "MailingRoom__c",
  MailingFloor: "MailingFloor__c",
  MailingStreet: "MailingStreet__c",
  MailingSubDistrict: "MailingSubDistrict__c",
  MailingDistrict: "MailingDistrict__c",
  MailingCity: "MailingCity__c",
  MailingCountry: "MailingCountry__c",
  MailingPostalCode: "MailingPostalCode__c",
  ContactSalutation: "ContactSalutation__c",
  ContactNickName: "NickName__c",
  ContactFirstName: "FirstName__c",
  ContactLastName: "LastName__c",
  ContactPosition: "Position__c",
  ContactEmail: "Email__c",
  ContactMobileCountryCode: "MobileCountryCode__c",
  ContactMobileNumber: "MobilePhone__c",
  ContactPhoneCountryCode: "PhoneCountryCode__c",
  ContactPhoneNumber: "Phone__c",
  ContactFaxCountryCode: "FaxCountryCode__c",
  ContactFaxNumber: "Fax__c",
  InterestedPetroleumAsCustomer: "InterestedProductTypeAsCustomerTOP__c",
  InterestedPetrochemicalAsCustomer: "InterestedProductTypeAsCustomerTOP__c",
  InterestedLubeBaseAsCustomer: "InterestedProductTypeAsCustomerTOP__c",
  InterestedLABIXAsCustomer: "InterestedProductTypeAsCustomerTOP__c",
  InterestedCrudeAsCustomer: "InterestedProductTypeAsCustomerTOP__c",
  InterestedOtherAsCustomer: "InterestedProductTypeAsCustomerTOP__c",
  InterestedLubeBaseAsCustomerDesc: "LubeBaseProduct__c",
  InterestedLABIXAsCustomerDesc: "LABIXProduct__c",
  InterestedOtherAsCustomerDesc: "CustomerProductIdentification__c",
  InterestedCrudeAsSupplier: "InterestedProductTypeAsSupplierTOP__c",
  InterestedB100EthanolAsSupplier: "InterestedProductTypeAsSupplierTOP__c",
  InterestedPetroleumAndComponentAsSupplier:
    "InterestedProductTypeAsSupplierTOP__c",
  InterestedLongResidueAsSupplier: "InterestedProductTypeAsSupplierTOP__c",
  InterestedNormalParaffinAsSupplier: "InterestedProductTypeAsSupplierTOP__c",
  InterestedOtherAsSupplier: "InterestedProductTypeAsSupplierTOP__c",
  InterestedPetroleumAndComponentAsSupplierDesc:
    "PetroleumAndComponentsProducts__c",
  InterestedOtherAsSupplierDesc: "SupplierProductIdentification__c",
  EstimatedMonthlyPurchaseQuantity: "CompanyPurchasingVolumnperGrade__c",
  EstimatedMonthlyPurchaseUnit: "EstimatedMonthlyPurchaseUnit__c",
  StartTradingDate: "StartTradingDate__c",
  DestinationCountries: "shippingCountries",
  RequestItems: "requestItems",
  Shareholders: "shareholders",
  Documents: "documents",
  PurchaseProductFromCompany: "CustomerPurchaseProductFrom__c",
  SupplyProductToCompany: "SupplierSupplyProductTo__c",
  OwnStorageAsCustomer: "CustomersFacilityTankAndStorage__c",
  RentStorageMoreThanOneYearAsCustomer: "CustomersFacilityTankAndStorage__c",
  RentStorageLessThanOneYearAsCustomer: "CustomersFacilityTankAndStorage__c",
  NoStorageAsCustomer: "CustomersFacilityTankAndStorage__c",
  OwnTransportAsCustomer: "CustomersFacilityTransportation__c",
  RentTransportMoreThanOneYearAsCustomer: "CustomersFacilityTransportation__c",
  RentTransportLessThanOneYearAsCustomer: "CustomersFacilityTransportation__c",
  NoTransportAsCustomer: "CustomersFacilityTransportation__c",
  OwnStorageAsSupplier: "SuppliersFacilityTankAndStorage__c",
  RentStorageMoreThanOneYearAsSupplier: "SuppliersFacilityTankAndStorage__c",
  RentStorageLessThanOneYearAsSupplier: "SuppliersFacilityTankAndStorage__c",
  NoStorageAsSupplier: "SuppliersFacilityTankAndStorage__c",
  OwnTransportAsSupplier: "SuppliersFacilityTransportation__c",
  RentTransportMoreThanOneYearAsSupplier: "SuppliersFacilityTransportation__c",
  RentTransportLessThanOneYearAsSupplier: "SuppliersFacilityTransportation__c",
  NoTransportAsSupplier: "SuppliersFacilityTransportation__c",
  CustomersFacilityTankAndStorage: "CustomersFacilityTankAndStorage__c",
  CustomersFacilityTransportation: "CustomersFacilityTransportation__c",
  SuppliersFacilityTankAndStorage: "SuppliersFacilityTankAndStorage__c",
  SuppliersFacilityTransportation: "SuppliersFacilityTransportation__c",
  EnvironmentPolicy: "EnvironmentPolicy__c",
  SocialResponsibilityPolicy: "SocialResponsibilityPolicy__c",
  CorporateGovernancePolicy: "CorporateGovernancePolicy__c",
  OccupationalHealthAndSafetyPolicy: "OccupationalHealthAndSafetyPolicy__c",
  HumanRightsPolicy: "HumanRightsPolicy__c",
  ViolatingAntiMoneyLaunderingLaws: "HasIssuesDuringThePast5Years__c",
  ReasonOfViolatingAntiMoneyLaunderingLaws:
    "SpecifyIssuesDuringThePast5Years__c",
  PaymentOverTheAmountOfUSD: "PaymentOverTheAmountOfUSD__c",
  ReasonOfPaymentOverTheAmountOfUSD: "ReasonOfTheDefault__c",
  FailedSupplyAgreement: "HasFailedSupplyInLast3Years__c",
  ReasonOfFailedSupplyAgreement: "SpecifyFailedSupplyInLast3Years__c",
  HaveTagetsInSanction: "HasSanctionedTarget__c",
  ReasonOfHaveTagetsInSanction: "SpecifySanctionedTarget__c",
  CEOFirstName: "CEOFirstName__c",
  CEOLastName: "CEOLastName__c",
  ImmidiateParentCompany: "ImmidiateParentCompany__c",
  UltimateParentCompany: "UltimateParentCompany__c",
  MainService: "MainService__c",
  OtherMainService: "OtherMainService__c",
  MainProduct: "MainProduct__c",
  OtherMainProduct: "OtherMainProduct__c",
  CompanyLatestCreditRating: "CompanyLatestCreditRating__c",
  LeadOwner: "Customer__r?.LeadOwner__c",
  OwnerId: "Customer__r?.OwnerId",
  IsSubmitted: "IsSubmitted__c",
  SubmittedDate: "AddInfoSubmittedDate__c",
  CompanyStatus: "CompanyStatus__c",
};
